import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NextButton from "../components/NextButton";
import { setGroup } from "../redux/actions";
import { useLang } from "../translations/i18n";
import { ROUTES } from "../utils/constants";
import { updateStats, clearItem, clearLastTick } from "../utils/helpers";

function Congratulations({ intl }) {
	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const group = useSelector((state) => state.group);

	useEffect(() => {
		
		if (group) {
			dispatch(
				setGroup({
					...group,
					lastVisited: ROUTES.RESULTS,
					finished: true,
				})
			);
			updateStats({
				...group,
				lastVisited: ROUTES.RESULTS,
				finished: true,
			});
		}
	}, []);

	return (
		<div className="h-100">
			<div
				className="container-fluid bg-confeti h-100 d-flex justify-content-center align-items-center"
				onClick={() => {
					updateStats({
						...group,
						finished: true,
						lastVisited: ROUTES.RESULTS,
					});
					navigate(ROUTES.RESULTS);
				}}
			>
				<div className="row h-50">
					<div className="col-12">
						<div className="text-center py-5" style={{ backgroundColor: "#FFFFFFAA", borderRadius: "10px", padding: "20px"}}>
							<div className="txt42 txtRed bold">
								¡FELICIDADES!
							</div>
							<div className="txtRed txt24">
								<div className="mt-4">
									Has resuelto el Patient Room. Muchas gracias por
									participar.
								</div>
								<div className="mt-2">
									Y ahora,{" "}
									<span className="bold">
										¿quieres conocer tu puntuación?
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					className="px-5"
					style={{ position: "absolute", right: "0", bottom: "7%" }}
				>
					<NextButton
						text={"VER RESULTADOS"}
						navigateTo={ROUTES.RESULTS}
					></NextButton>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Congratulations);
